export const BI_EVENT_TYPES = {
    NO_RESULTS_IMPRESSION: 'pro_catalog_no_results_banner_is_shown',
    LET_CHAT_CLICK: 'clicked_on_lets_chat',
    NO_RESULTS_BRIEF_CLICK: 'clicked_on_fiverr_pro_brief_and_match',
    PRO_CLEAR_FILTERS_CLICK: 'clicked_on_clear_filters',
};
